import ReachTooltip from "@reach/tooltip";
import styled from "styled-components";

const Tooltip = styled(ReachTooltip)`
  border-radius: 4px;
  font-size: 0.75rem;
`;

export default Tooltip;
